// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/contact-bar/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteContactBarEN: PageEntry = {
  id: "example.produkte-kontaktschiene",
  locale: "en",
  slug: "produkte/contact-bar",
  seo: {
    title: "Contact bar | Dietz GmbH",
    description: "Connector in power distributor: Combination of stamped-formed parts, technical springs and plastic moulded parts. These assemblies are produced through various assembly processes (",
  },
  type: "post",
  h1: "Contact bar",
  intro: "Connector in power distributor: Combination of stamped-formed parts, technical springs and plastic moulded parts. These assemblies are produced through various assembly processes (joining, pressing, soldering)",
  blocks: [
    { kind: "image", src: "/images/live/dtz-kontaktschiene.jpg", alt: "Contact bar", width: 1400, height: 1120 }
  ],
};
